import React from "react";
const ProcessHeader = props => {
  return <div dangerouslySetInnerHTML={{ __html: props.processHeader }} />;
};

export default ProcessHeader;
